<template>
  <div>
    <!-- Edit Modal -->
    <b-modal id="editUserData" :title="emailEdit
        ? `Change Email for ${profile.first_name} ${profile.last_name}`
        : `Change Mobile for ${profile.first_name} ${profile.last_name}`
      " no-close-on-backdrop no-close-on-keyboard no-close-on-esc hide-header-close hide-footer size="md" centered
      modal-class="editUserData">
      <EditDetails :emailEdit="emailEdit" @closeModal="$bvModal.hide('editUserData');refreshPage();" />
    </b-modal>
    <b-card class="section-container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-6">

          <!-- Centered Component -->
          <EnrollUserToInstitute lazy />

        </div>
     </div>
    </b-card>

    <b-card class="section-container">
      <!-- About Header -->
      <b-row align-v="center" class="mb-3">
        <b-col>
          <h5 class="text-uppercase font-weight-bold">
            <i class="fas fa-user mr-2" style="font-size: 20px !important;"></i>Login Info
          </h5>
        </b-col>
        <b-col class="text-right">
          <span class="btn p-0 text-info" @click="$emit('editProfile')">
            <i class="fas fa-edit" style="font-size: 18px !important;"></i>
          </span>
        </b-col>
      </b-row>

      <!-- Personal Information -->
      <b-row class="py-1 align-items-center border-bottom">
        <b-col md="3" class="label">Name</b-col>
        <b-col md="3" class="value">
          <template v-if="!profile.id">
            <b-skeleton animation="throb" width="70%"></b-skeleton>
          </template>
          <template v-else>{{ fullName || '-' }}</template>
        </b-col>

        <b-col md="3" class="label">Username</b-col>
        <b-col md="3" class="value">
          <template v-if="!profile.id">
            <b-skeleton animation="throb" width="70%"></b-skeleton>
          </template>
          <template v-else>{{ user.username || '-' }}</template>
        </b-col>
      </b-row>

      <b-row class="py-1 align-items-center border-bottom">
        <b-col md="3" class="label">Email</b-col>
        <b-col md="3" class="value d-flex align-items-center">
          <template v-if="!profile.id">
            <b-skeleton animation="throb" width="70%"></b-skeleton>
          </template>
          <template v-else>
            {{ user.email || '-' }}
            <span class="btn p-0 ml-2 text-info" @click="editEmailOrMobile(true)">
              <i class="fas fa-edit" style="font-size: 18px !important;"></i>
            </span>
          </template>
        </b-col>

        <b-col md="3" class="label">Mobile</b-col>
        <b-col md="3" class="value d-flex align-items-center">
          <template v-if="!profile.id">
            <b-skeleton animation="throb" width="70%"></b-skeleton>
          </template>
          <template v-else>
            {{ user.mobile || '-' }}
            <span class="btn p-0 ml-2 text-info" @click="editEmailOrMobile(false)">
              <i class="fas fa-edit" style="font-size: 18px !important;"></i>
            </span>
          </template>
        </b-col>
      </b-row>

      <b-row class="py-1 align-items-center">
        <b-col md="3" class="label">Communication Address</b-col>
        <b-col md="3" class="value">
          <template v-if="!profile.id">
            <b-skeleton animation="throb" width="100%"></b-skeleton>
          </template>
          <template v-else>{{ communicationAddress || '-' }}</template>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import EditDetails from "../EditDetails.vue";
import EnrollUserToInstitute from '@/components/templates/Dashboard/Institute/settings/EnrollUserToInstitute.vue';
export default {
  props: ["profile", "user"],
  components: { EditDetails,
    EnrollUserToInstitute
   },
  data() {
    return {
      emailEdit: false,
    };
  },
  computed: {
    fullName() {
      if (!this.profile) return '';
      return `${this.profile.first_name || ''} ${this.profile.last_name || ''}`.trim();
    },
    communicationAddress() {
      if (!this.profile) return '';
      const parts = [
        this.profile.address_street,
        this.profile.address_city,
        this.profile.address_state,
        this.profile.address_country,
        this.profile.address_postcode
      ].filter(Boolean); // remove null/empty
      return parts.join(' - ');
    },
  },
  methods: {
    refreshPage() {
      window.location.reload();
    },
  
    editEmailOrMobile(status) {
      this.emailEdit = status;
      this.$bvModal.show("editUserData");
    },
  },
};
</script>

<style scoped>
.section-container {
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 0px;
}

.label {
  font-weight: 600;
  text-transform: capitalize;
  color: #555;
}

.value {
  font-weight: 500;
  color: #333;
}
</style>
